import { types } from './types';

export const setGetPaymentsMethodAction = (payload) => {
  return {
    type: types.SET_GET_PAYMENT_METHOD,
    payload,
  }
}

export const setGetPaymentsMethodByIdAction = (payload) => {
  return {
    type: types.SET_GET_PAYMENT_METHOD_BY_ID,
    payload
  }
}